import { Controller } from '@hotwired/stimulus'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'

export default class extends Controller {
  static values = {
    smsRouteId: String
  }

  toggleIsOnboardingEnabled (event) {
    event.stopPropagation()
    const currentTarget = event.currentTarget

    fetchWithHandlingLoginRedirect(`/internal/api/sms-routes/${this.smsRouteIdValue}/toggle-onboarding`, { method: 'POST' })
      .catch(() => { currentTarget.checked = !currentTarget.checked })
  }
}
